import { Component, ChangeDetectionStrategy, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Model } from 'src/app/shared/models/clux/model-legacy';

@Component({
  selector: 'app-forgot-password-federated-modal',
  templateUrl: 'forgot-password-federated-modal.component.html',
  styleUrls: ['./forgot-password-federated-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class ForgotPasswordFederatedModalComponent {
  public dialog = inject(MatDialog);
  public data = inject<Model.MatDialogModel>(MAT_DIALOG_DATA);
  private modalRef = inject<MatDialogRef<ForgotPasswordFederatedModalComponent>>(MatDialogRef);

  private identityProvider: string;

  public close(): void {
    this.modalRef.close();
  }
}
